import { mapDataCloudfrontURL } from "./MapConstants";
import JSZip from "jszip";

export const getAniaMap = async (): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}ania/cys_hazards_ania_v2_opt.zip`;
  return getZippedGeoJson(url);
};

export const getCoCoZippedGeoJson = async (name: string): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}coco_map/${name}.zip`;
  return getZippedGeoJson(url);
};

export const getProCivileTodayMap = async (): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}protezionecivile-bollettino/today.zip`;
  return getZippedGeoJson(url);
};

export const getProCivileTomorrowMap = async (): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}protezionecivile-bollettino/tomorrow.zip`;
  return getZippedGeoJson(url);
};

export const getCrimeDataMapSwe = async (): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}crime/anmalda_brott_kommuner_2024.zip`;
  return getZippedGeoJson(url);
};

export const getNasaCastPrecipitationItaGeoJson = async (days: number): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}nasa_nowcast/cys_nowc_precp_ita_nasagpm_${days}day.zip`;
  return getZippedGeoJson(url);
};

export const getNasaCastLandslideItaGeoJson = async (): Promise<GeoJsonData> => {
  const url = `${mapDataCloudfrontURL}nasa_nowcast/cys_nowc_lslde_ita_nasagpm.zip`;
  return getZippedGeoJson(url);
};

export const getZippedGeoJson = async (url: string): Promise<GeoJsonData> => {
  try {
    const response = await fetch(url, { cache: "no-cache" });
    // Note, any files that are potentially updated should not be cached.

    if (response.status !== 200) {
      throw new Error(`Failed to fetch zip file from url ${url}: ${response.statusText}`);
    }
    const blob = await response.blob();
    const zip = await JSZip.loadAsync(blob);

    const firstFileName = Object.keys(zip.files)[0];
    const text = await zip.file(firstFileName)?.async("string");
    if (text) {
      const parsed = JSON.parse(text);
      const geojson = parsed as GeoJsonData;
      return geojson;
    } else {
      throw new Error(`File ${firstFileName} is empty`);
    }
  } catch (err) {
    console.error(err);
  }
  return {} as GeoJsonData;
};

// Design note: one can use this function this way:
//
//(async () => {
//  const gotAniaMap = await getAniaMap();
//  setItaAniaWindLevelGeoJson(gotAniaMap );
//})();
//
//      or
//
//getAniaMap().then((geojson) => {
//  setItaAniaWindLevelGeoJson(geojson);
//});
